import { render, staticRenderFns } from "./RequestDocumentation.vue?vue&type=template&id=afc5c922"
import script from "./RequestDocumentation.vue?vue&type=script&lang=js"
export * from "./RequestDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports